// extracted by mini-css-extract-plugin
export default {"container":"About_container__v143G","content":"About_content__qxQEq","title":"About_title__rg61T","description":"About_description__8eONl"};